"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const network_1 = require("./network");
/**
* @ignore
*/
const config = {
    network: network_1.network.defaults.MAINNET_DEFAULT,
    logLevel: 'debug'
};
exports.config = config;
//# sourceMappingURL=config.js.map